import { useEffect } from "react";

const BASE = "https://y-bethalpha.org";
const BRAND = "y ℶα  INFINITE TIMES";
const DEFAULT_OG_IMAGE = "https://static.prod-images.emergentagent.com/jobs/63a57259-d272-4099-a07a-ad9d443a994a/images/d16caaeb38589f59d5516de9caa20bc49fff4c9a64f58c9b69db7538b5360017.png";

function upsertMeta({ attr, key, content }) {
  if (!content) return;
  let tag = document.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function upsertLink({ rel, href }) {
  if (!href) return;
  let tag = document.querySelector(`link[rel="${rel}"]`);
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", rel);
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", href);
}

/**
 * Set page-specific SEO metadata for SPA routes:
 *  - <title>  → "{title} — y ℶα  INFINITE TIMES"
 *  - <meta name="description">
 *  - <link rel="canonical">
 *  - Open Graph + Twitter Card tags (title/description/url/image)
 */
export default function useSEO({ title, description, path, image }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${BRAND}` : BRAND;
    document.title = fullTitle;

    const url = path ? `${BASE}${path}` : BASE + "/";
    const ogImage = image || DEFAULT_OG_IMAGE;

    upsertMeta({ attr: "name", key: "description", content: description });

    // Canonical
    upsertLink({ rel: "canonical", href: url });

    // Open Graph
    upsertMeta({ attr: "property", key: "og:title", content: fullTitle });
    upsertMeta({ attr: "property", key: "og:description", content: description });
    upsertMeta({ attr: "property", key: "og:url", content: url });
    upsertMeta({ attr: "property", key: "og:image", content: ogImage });
    upsertMeta({ attr: "property", key: "og:type", content: "website" });
    upsertMeta({ attr: "property", key: "og:site_name", content: "y ℶα" });

    // Twitter
    upsertMeta({ attr: "name", key: "twitter:card", content: "summary_large_image" });
    upsertMeta({ attr: "name", key: "twitter:title", content: fullTitle });
    upsertMeta({ attr: "name", key: "twitter:description", content: description });
    upsertMeta({ attr: "name", key: "twitter:image", content: ogImage });
    upsertMeta({ attr: "name", key: "twitter:url", content: url });
  }, [title, description, path, image]);
}
